import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const slug = 'concrete-stairs-and-columns-sydney';
const serviceId = 5
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Concrete Stairs & Columns Sydney | ${BUSINESS_NAME}`,
        description: "Custom-formed concrete stairs, walls, and structural columns.",
        keywords: "concrete stairs Sydney, concrete columns Sydney, custom concrete stairs, structural concrete columns, residential concrete stairs, commercial concrete stairs, industrial concrete stairs, reinforced concrete columns, architectural concrete stairs, durable concrete structures, Sydney construction services",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Concrete Stairs & Columns',
    description: 'Custom-formed concrete stairs, walls, and structural columns.',
    points: [

    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
